import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { fetchCompanyAiMailboxMessage } from "../../../api/microsoft";
import {
  graphMessageIdFromComm,
  mailBodyFromGraphMessage,
} from "../../../utils/mailThread";
import { CaseEmailHtmlBody } from "./CaseEmailHtmlBody";

const TIMELINE_IFRAME_CLASS = "h-[min(32vh,280px)] w-full border-0";

/**
 * Compact Mailtråd-style HTML in the case timeline.
 * Graph HTML when the mailbox is readable; otherwise stored body_html / body_text.
 */
export function CaseTimelineMailBody({ comm, mailboxId, onOpenThread }) {
  const { t } = useTranslation();
  const graphId = graphMessageIdFromComm(comm);
  const canFetchGraph = Boolean(mailboxId && graphId);
  const [graph, setGraph] = useState(null);
  const [graphPending, setGraphPending] = useState(canFetchGraph);

  useEffect(() => {
    if (!canFetchGraph) {
      setGraph(null);
      setGraphPending(false);
      return undefined;
    }
    let cancelled = false;
    setGraphPending(true);
    fetchCompanyAiMailboxMessage(mailboxId, graphId)
      .then((data) => {
        if (!cancelled) setGraph(data?.message || null);
      })
      .catch(() => {
        if (!cancelled) setGraph(null);
      })
      .finally(() => {
        if (!cancelled) setGraphPending(false);
      });
    return () => {
      cancelled = true;
    };
  }, [canFetchGraph, mailboxId, graphId]);

  const fromGraph = mailBodyFromGraphMessage(graph);
  const html = fromGraph.html || (!graphPending ? comm?.body_html : "");
  const text = fromGraph.html
    ? ""
    : fromGraph.text || (!graphPending ? comm?.body_text : "");

  return (
    <div className="cv-module-card-mail">
      {graphPending ? (
        <p className="mt-2 text-sm text-slate-500">{t("case.mail_thread.body_loading")}</p>
      ) : (
        <div className="mt-2">
          <CaseEmailHtmlBody
            html={html}
            text={text}
            title={comm?.subject || t("microsoft.ai_mailboxes.reader.body_iframe_title")}
            iframeClassName={TIMELINE_IFRAME_CLASS}
          />
        </div>
      )}
      <button
        type="button"
        className="cv-module-card-link mt-2"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          onOpenThread?.(comm);
        }}
      >
        {t("case.mail_thread.open")}
      </button>
    </div>
  );
}
